import { createContext, useContext } from 'react';
import type {
  MinimizedDrawerItem,
  MinimizedDrawersState,
} from '../../../shared/hooks/useMinimizedDrawersState';

export type { MinimizedDrawerItem };

export type MinimizedDrawersContextType = MinimizedDrawersState;

export const MinimizedDrawersContext = createContext<
  MinimizedDrawersContextType | undefined
>(undefined);

export const useMinimizedDrawers = () => {
  const context = useContext(MinimizedDrawersContext);
  if (context === undefined) {
    throw new Error(
      'useMinimizedDrawers must be used within a MinimizedDrawersProvider',
    );
  }
  return context;
};
